import { isObject } from 'ramda-adjunct'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const localStorageService = (storage = localStorage) => {
  // Please note that getValue is not returned and exported
  // (only typed variables can be accessed)
  const getValue = (key) => storage.getItem(key)

  const setValue = (key, value) => {
    const encodedValue = isObject(value) ? JSON.stringify(value) : value
    storage.setItem(key, encodedValue)
  }

  const clearValue = storage.removeItem

  const clearAll = storage.clear

  const hasValue = (key) => getValue(key) !== null

  const doesNotHaveValue = (key) => getValue(key) === null

  const getString = (key) => getValue(key)

  const getBoolean = (key) => {
    const value = getValue(key)
    return value === `true`
  }

  const getObject = (key) => {
    const value = getValue(key)
    return JSON.parse(value)
  }

  return {
    setValue,
    hasValue,
    doesNotHaveValue,
    getString,
    getBoolean,
    getObject,
    clearValue,
    clearAll,
  }
}

export default localStorageService
